import type { CSSProperties } from 'react';

/**
 * Shared props for every Illustration* component in this folder.
 *
 * Shell: any. Illustrations are stateless presentational SVGs rendered
 * inside `EmptyState` (and anywhere else a resource-typed empty surface
 * is needed).
 */
export interface IllustrationProps {
  /** Square-ish pixel width applied to the SVG. Defaults to 120. Height scales 4:3. */
  size?: number;
  /** Optional className forwarded to the root `<svg>` element. */
  className?: string;
  /** Optional inline style forwarded to the root `<svg>` element. */
  style?: CSSProperties;
}

/** Primary accent stroke colour driven by Mantine's primary palette. */
export const ACCENT = 'var(--mantine-primary-color-filled)';
/** Subtle secondary stroke colour matching the default border token. */
export const MUTED = 'var(--mantine-color-default-border)';
